module.exports = __webpack_public_path__ + "static/Fastfarma-2c59d540af4241ea18fa83952bed3d7b.png";